// removed by extract-text-webpack-plugin
module.exports = {"confirmContentError":"Gebada7","submitButton":"G9f45a4 Gaf382d"};